<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/n9GNJt/tc-custom/9781617451874.jpg?1737674163777" alt="This image is the cover for the book Festive Fall Quilts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Festive Fall Quilts
      </h1>
      <p class="bookDescription body article font2">
        <b>21 quick and easy quilting projects to give your home a touch of whimsy in the fall, by the bestselling author of <i>Playtime, Naptime, Anytime Quilts</i>.</b><br/><br/>From bestselling author Kim Schaefer comes this collection of 21 engaging piecing and applique projects for fall, including tried-and-true motifs such as pumpkins, sunflowers, acorns, turkeys, and autumn leaves. Plus, celebrate Halloween with spooky spiders, friendly bats, expressive jack-o-lanterns, and much more! Make projects in a variety of sizes, from tea towels and placemats to lap quilts and table runners. These quick and easy projects will brighten up your home for fall!<br/><br/><b>Praise for <i>Festive Fall Quilts</i></b><br/><br/><b>“Sewers can harvest loads of fun decorating the house for autumn. The adorable appliqués in this book have a multitude of uses on place mats, runners, table toppers, wall quilts or fun towel embellishments.” —<i>American Quilt Retailer</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Schaefer
      </h2>
      
      <p class="authorDescription body article">Kim Schaefer Bio: Kim Schaefer is the founder of Little Quilt Company, a pattern company focused on designing a variety of small, fun-to-make projects. A best-selling author, Kim also designs fabric for Andover Fabrics. She lives with her family in Southeastern Wisconsin. littlequiltcompany.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1020b773